<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :title="$lang.interviewDone"
      :url="url"
      :html="false"
      ref="interviewLocationPerson"
      @updatePermissions="updatePermissions"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 mb-3 border-bottom d-md-flex d-block align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle d-flex align-items-center justify-content-center"
            >
              <i class="far fa-calendar-check text-primary" />
            </span>
            <b
              v-b-tooltip
              :title="
                pathOr(
                  '',
                  ['interview_location_plan_id'],
                  $lang.searchinterviewDone
                )
              "
              class="px-1 fs_1rem"
              v-text="item.interview_location_plan_id"
            /><b
              v-b-tooltip.hover
              :title="
                pathOr(
                  '',
                  ['audience.parvandeh.term_caption'],
                  $lang.searchinterviewDone
                )
              "
              v-text="` - ${item.audience.parvandeh.term_caption}`"
            ></b>
          </div>
          <small
            class="text-muted d-md-block d-flex align-items-center justify-content-between"
          >
            <div v-b-tooltip title="زمان ایجاد">
              <i class="fas fa-clock mr-1" />
              <span
                dir="ltr"
                v-text="pathOr('', ['created_at', 'jalali'], item)"
              />
            </div>
          </small>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col cols="12" md="3" class="text-center mt-1">
              <div class="card">
                <div class="p-1 bg-info">
                  <b>{{
                    pathOr(
                      "",
                      ["interview_date.jalali"],
                      $lang.searchinterviewDone
                    )
                  }}</b>
                </div>
                <span
                  class="p-2"
                  dir="ltr"
                  v-text="pathOr('', ['interview_date', 'jalali'], item)"
                />
              </div>
            </b-col>

            <b-col cols="12" md="3" class="text-center mt-1">
              <div class="card">
                <div class="p-1 bg-info">
                  <b>{{
                    pathOr("", ["place_caption"], $lang.searchinterviewDone)
                  }}</b>
                </div>
                <span class="p-2" v-text="item.place_caption" />
              </div>
            </b-col>

            <b-col cols="12" md="" class="text-center mt-1">
              <div class="card">
                <div class="p-1 bg-info">
                  <b>{{
                    pathOr("", ["city_name"], $lang.searchinterviewDone)
                  }}</b>
                </div>
                <span class="p-2" v-text="item.city_name" />
              </div>
            </b-col>
            <b-col cols="12" md="" class="text-center mt-1">
              <div class="card">
                <div class="p-1 bg-info">
                  <b>{{
                    pathOr("", ["room_number"], $lang.searchinterviewDone)
                  }}</b>
                </div>
                <span class="p-2" v-text="item.room_number" />
              </div>
            </b-col>
            <b-col class="mt-3" cols="12" md="6">
              <div class="card">
                <b-row>
                  <b-col cols="12">
                    <div class="p-1 bg-info text-center">
                      <b class="mx-2 m-0">اطلاعات متقاضی</b>
                    </div>
                  </b-col>
                  <b-col cols="12" md="4" class="text-center">
                    <b class="ml-2">{{
                      pathOr(
                        "",
                        ["audience.parvandeh.parvandeh_number"],
                        $lang.searchinterviewDone
                      )
                    }}</b
                    ><br />
                    <span
                      v-text="
                        pathOr(
                          '',
                          ['audience', 'parvandeh', 'parvandeh_number'],
                          item
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="12" md="4" class="text-center"
                    ><b>{{
                      pathOr(
                        "",
                        ["audience.person.national_code"],
                        $lang.searchinterviewDone
                      )
                    }}</b>
                    <br />
                    {{ item.audience.person.national_code }}</b-col
                  >
                  <b-col cols="12" md="4" class="text-center"
                    ><b>{{
                      pathOr(
                        "",
                        ["audience.person.full_name"],
                        $lang.searchinterviewDone
                      )
                    }}</b
                    ><br />
                    <ProfileBoxPopupWrapper
                      :data="item.audience"
                      deskTopPopupClass="top-230"
                      nameClass="color-complementary"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="mt-3" cols="12" md="6">
              <div class="card">
                <b-row>
                  <b-col cols="12">
                    <div class="p-1 bg-info text-center">
                      <b class="mx-2 m-0">اطلاعات استاد</b>
                    </div>
                  </b-col>
                  <b-col cols="12" md="4" class="text-center">
                    <b class="ml-2"
                      >{{
                        pathOr(
                          "",
                          ["master.parvandeh.parvandeh_number"],
                          $lang.searchinterviewDone
                        )
                      }} </b
                    ><br />
                    <span
                      v-text="
                        pathOr(
                          '',
                          ['master', 'parvandeh', 'parvandeh_number'],
                          item
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="12" md="4" class="text-center">
                    <b
                      >{{
                        pathOr(
                          "",
                          ["master.person.national_code"],
                          $lang.searchinterviewDone
                        )
                      }} </b
                    ><br />
                    {{ item.master.person.national_code }}
                  </b-col>
                  <b-col cols="12" md="4" class="text-center">
                    <b
                      >{{
                        pathOr(
                          "",
                          ["master.person.full_name"],
                          $lang.searchinterviewDone
                        )
                      }} </b
                    ><br />
                    <ProfileBoxPopupWrapper
                      :data="item.master"
                      deskTopPopupClass="top-230"
                      nameClass="color-complementary"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-top py-2 mt-3" cols="12">
          <b-row align-v="center" align-h="between" class="w-100 m-0">
            <b-col cols="12" md="6" class="px-0">
              <b-badge class="mx-1" variant="success"
                ><b
                  v-b-tooltip
                  :title="
                    pathOr('', ['state.caption'], $lang.searchinterviewDone)
                  "
                >
                  {{ item.state.caption }}</b
                ></b-badge
              >
              <b-badge
                class="mx-1"
                dir="ltr"
                v-if="pathOr(null, ['complete_at', 'jalali'], item)"
                variant="primary"
                ><b
                  v-b-tooltip
                  :title="
                    pathOr(
                      '',
                      ['complete_at.jalali'],
                      $lang.searchinterviewDone
                    )
                  "
                  >{{ pathOr("", ["complete_at", "jalali"], item) }}</b
                ></b-badge
              >
              <b-badge
                class="mx-1"
                :variant="
                  item.interview_voice_recorded == 'ندارد'
                    ? `danger`
                    : `success`
                "
              >
                <b
                  v-b-tooltip
                  :title="
                    pathOr(
                      '',
                      ['interview_voice_recorded'],
                      $lang.searchinterviewDone
                    )
                  "
                  >{{ item.interview_voice_recorded }}</b
                ></b-badge
              >
            </b-col>
            <b-col cols="12" md="6" class="text-right px-0">
              <b-overlay
                :show="rejectLoading"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="danger"
                class="d-inline-block"
              >
                <b-button
                  v-if="
                    isAdmin(permissions) &&
                    includes(pathOr(null, ['state', 'id'], item), [2])
                  "
                  variant="outline-danger"
                  size="sm"
                  class="mr-1"
                  :disabled="rejectLoading"
                  @click="reject(item)"
                >
                  <i class="fas fa-history fa-lg mr-1" />
                  <b v-text="'بازگشت مصاحبه'" />
                </b-button>
              </b-overlay>
              <b-button
                v-if="isAdmin(permissions, ['admin'])"
                class="m-1"
                variant="primary"
                size="sm"
                @click="goToFinalReport(item)"
              >
                <i class="fas fa-address-card fa-lg mr-1" />
                {{ $lang.showReportCard }}
              </b-button>
              <b-button
                v-if="
                  isAdmin(permissions) &&
                  includes(pathOr(null, ['state', 'id'], item), [1, 2])
                "
                variant="success"
                size="sm"
                @click="modalEdit(item)"
              >
                <i class="fas fa-eye fa-lg mr-1" />
                <b v-text="'مشاهده پرسشنامه‌ها و پیوست‌ها'" />
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      v-model="view_add"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <ShowInterviewDone
        v-if="Object.keys(item).length > 0"
        :item="item"
        @cancel="closeModal"
      />
    </b-modal>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import ShowInterviewDone from "./showInterviewDone";
import SearchCard from "@/components/base/searchCard";
import { pathOr, includes } from "ramda";
import { isAdmin, goToRoute } from "@/shared/utils";

export default {
  components: {
    ShowInterviewDone,
    SearchCard,
    ProfileBoxPopupWrapper,
  },
  name: "interviewLocationPerson-search",
  inject: ["interviewLocationPersonRepository", "interviewDoingRepository"],
  data() {
    return {
      mode: "",
      item: {},

      id: this.$route.params.id,
      url: this.$config.api_url + this.$config.interview.interview_done,
      hiddenFields: ["created_by"],
      isLoading: false,
      view_add: false,
      buttons: [
        {
          id: "1",
          name: "editView",
          click: this.modalEdit,
          title: "مشاهده پرسشنامه‌ها و پیوست‌ها",
          state: [1, 2],
        },
        {
          id: "1",
          name: "reject",
          click: this.reject,
          state: [2],
        },
      ],
      itemTopHeader: [
        {
          colspan: 7,
          name: "اطلاعات مصاحبه",
          variant: "warning",
        },
        {
          colspan: 4,
          name: "متقاضی",
          variant: "success",
        },
        {
          colspan: 3,
          name: "استاد",
          variant: "info",
        },
      ],
      permissions: [],
      rejectLoading: false,
    };
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    goToRoute,
    dynamicButtons(item) {
      let stateId = item.state && item.state.id;
      return this.buttons.filter((x) => x.state.includes(stateId));
    },
    closeModal() {
      this.view_add = false;
    },
    modalEdit(item) {
      this.item = item;
      this.mode = "edit";
      this.view_add = true;
    },
    modalAdd() {
      this.mode = "add";
      this.view_add = true;
    },
    async reject(item) {
      try {
        this.rejectLoading = true;
        let payload = {
          interview_complete: 0,
        };
        const response = await this.interviewDoingRepository.partial_edit(
          item.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.$refs.interviewLocationPerson.getItems();
      } catch (err) {
        this.$generateError(err);
      } finally {
        this.rejectLoading = false;
      }
    },
    async remove_item(item) {
      try {
        let response = await this.interviewLocationPersonRepository.delete(
          item.id
        );
        this.$notify.success(response.data.message);
      } catch (err) {
        this.$generateError(err);
      }
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    goToParvandeh(parvandeh_number = null) {
      const routerData = this.$router.resolve({
        name: "parvandeh_by_number",
        params: { parvandeh_number },
      });
      return routerData.href;
    },
    goToFinalReport(item) {
      const name = "interview_final_result";
      const params = {
        code: pathOr(null, ["audience", "parvandeh", "code"], item),
      };
      goToRoute(name, params);
    },
  },
};
</script>

<style>
.box-blue {
  background: cornflowerblue;
  color: white;
  padding: 3px 0;
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
.circle-box {
  border-radius: 60%;
  border: 1px solid lightgray;
  width: 35px;
  height: 35px;
  background: cornflowerblue;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
}
</style>
